import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirplaneTicketIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airplane_ticket"}/>
}
